import React from 'react';
import {times} from 'lodash';
import 'stylesheets/components/college-success/loading.scss';

const Loading = () => (
  <div className="shared-carousel loading" data-testid="loading">
    <div className="shared-carousel-display">
      {times(5, (n) => (
        <section className="shared-card small add-to-portfolio-card" key={n}>
          <div className="add-to-portfolio-card-emoji shared-shimmer" />
          <div className="add-to-portfolio-card-title shared-shimmer-text small" />
          <div className="add-to-portfolio-card-button shared-shimmer">
            <div className="shared-shimmer-text button-text small" />
          </div>
        </section>
      ))}
    </div>
  </div>
);

export default Loading;
